import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringToDate',
  // standalone: true,
})
export class StringToDatePipe implements PipeTransform {
  transform(dateString: string | undefined): Date | null {
    if (!dateString) {
      return null;
    }
    // Convert String object to primitive string
    const primitiveString: string = dateString.toString();
    // Parse the string date to a Date object
    return new Date(primitiveString);
  }
}
